import "./App.css";
import Footer from "./components/Footer";
import Header from "./components/Header";
import HomePage from "./pages/HomePage";

function App() {
  return (
    <div className="flex flex-col items-center">
      <Header />
      <HomePage />
      <Footer />
    </div>
  );
}

export default App;
